import React from 'react';
import ATable from '../../common/table';

const DisputeTimelinesTable = (props) => {


    const columns = [{
        header: "S/N",
        width: 50,
        render: row => (<div>{row.viewIndex + 1}</div>)
    },
    {
        header: "Dispute Region",
        accessor: "disputeRegion"
    },
    {
        header: "Dispute Category",
        accessor: "disputeCategory",
    },
    {
        header: "Dispute Status",
        accessor: "disputeStatus",
    },
    {
        header: "Valid Time (Hours)",
        accessor: "validTime",
    }
    ];
    return (
        <ATable
            className="-striped -highlight"
            tableData={props.disputeTimelines}
            columns={columns}
            onChange={props.onTableChange || null}
            manual
            {...props} />
    )
};

export default DisputeTimelinesTable;


// WEBPACK FOOTER //
// ./src/components/admin/disputeTimelines/disputeTimelinesTable.js